const apiConfig = {
  url: "https://api.islandswatch.com/api/",
}
export default apiConfig;
